<div class="tabs-container">
  <mat-tab-group
    [mat-stretch-tabs]="stretch"
    [selectedIndex]="selectedIndex"
    (selectedIndexChange)="onTabChange($event)"
  >
  
  <ng-container *ngFor="let tab of tabs">
    <mat-tab [label]="tab.name"></mat-tab>
  </ng-container>
    
  </mat-tab-group>
</div>
